import { render, staticRenderFns } from "./RealizarVenta.vue?vue&type=template&id=70605a82&scoped=true&"
import script from "./RealizarVenta.vue?vue&type=script&lang=js&"
export * from "./RealizarVenta.vue?vue&type=script&lang=js&"
import style0 from "./RealizarVenta.vue?vue&type=style&index=0&id=70605a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70605a82",
  null
  
)

export default component.exports